<template>
  <div class="w-full h-screen bg-white overflow-x-hidden">
    <Navbar @sidebarDismissed=" (value) => {expand(value)}"  class=" w-full sticky top-0 z-50"/>
    <div>
      <Sidebar class="sidebar"/>
      <div :class="[!expandBody ? 'main px-5 space-y-2 margin mb-16' : 'main px-5 space-y-2 mb-16']">
        <!-- the top route and username grid -->
        <div class="justify-between flex pt-5 text-size-md font-medium text-gray-500 w-full">
          <span class=" text-emerald-500" >> Home > Create Request Step 6</span>
          <span v-if="employee !== null">{{ employee.firstname }} {{ employee.surname }} </span>
        </div>
        <!-- the requests charts -->
        <div class="grid gap-6 grid-rows-1 grid-cols-1">
          <div class=" shadow-md text-gray-400 col-span-full border hover:shadow-lg mt-4 bg-white">
            <!-- The chart title -->
            <div class="ml-8 flex mt-6 mb-4 items-center space-x-1">
              <!-- <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-emerald-500 fill-current" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="512" height="512"><path d="M24,24H3a3,3,0,0,1-3-3V0H2V21a1,1,0,0,0,1,1H24Z"/><rect x="14" y="11" width="2" height="9"/><rect x="6" y="11" width="2" height="9"/><rect x="18" y="6" width="2" height="14"/><rect x="10" y="6" width="2" height="14"/></svg> -->
              <!-- <svg class="h-4 w-4 text-emerald-500 fill-current" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24">
                <path d="m12,12c3.309,0,6-2.691,6-6S15.309,0,12,0s-6,2.691-6,6,2.691,6,6,6Zm0-10c2.206,0,4,1.794,4,4s-1.794,4-4,4-4-1.794-4-4,1.794-4,4-4Zm9,17v5h-2v-5c0-1.654-1.346-3-3-3h-2l-1.333,2,1.333,6h-4l1.333-6-1.333-2h-2c-1.654,0-3,1.346-3,3v5h-2v-5c0-2.757,2.243-5,5-5h8c2.757,0,5,2.243,5,5Z"/>
              </svg> -->
              <!-- <svg class="h-4 w-4 text-emerald-500 fill-current" xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="512" height="512"><path d="M18.4,7.379a1.128,1.128,0,0,1-.769-.754h0a8,8,0,1,0-15.1,5.237A1.046,1.046,0,0,1,2.223,13.1,5.5,5.5,0,0,0,.057,18.3,5.622,5.622,0,0,0,5.683,23H11a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H5.683a3.614,3.614,0,0,1-3.646-2.981,3.456,3.456,0,0,1,1.376-3.313A3.021,3.021,0,0,0,4.4,11.141a6.113,6.113,0,0,1-.073-4.126A5.956,5.956,0,0,1,9.215,3.05,6.109,6.109,0,0,1,9.987,3a5.984,5.984,0,0,1,5.756,4.28,2.977,2.977,0,0,0,2.01,1.99,5.934,5.934,0,0,1,.778,11.09.976.976,0,0,0-.531.888h0a.988.988,0,0,0,1.388.915c4.134-1.987,6.38-7.214,2.88-12.264A6.935,6.935,0,0,0,18.4,7.379Z"/><path d="M18.707,16.707a1,1,0,0,0,0-1.414l-1.586-1.586a3,3,0,0,0-4.242,0l-1.586,1.586a1,1,0,0,0,1.414,1.414L14,15.414V23a1,1,0,0,0,2,0V15.414l1.293,1.293a1,1,0,0,0,1.414,0Z"/></svg> -->
              <!-- <svg class="h-4 w-4 text-emerald-500 fill-current" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="512" height="512"><path d="m17,0H7C4.243,0,2,2.243,2,5v14c0,2.757,2.243,5,5,5h10c2.757,0,5-2.243,5-5V5c0-2.757-2.243-5-5-5ZM7,2h10c1.654,0,3,1.346,3,3H4c0-1.654,1.346-3,3-3Zm10,20H7c-1.654,0-3-1.346-3-3V7h16v12c0,1.654-1.346,3-3,3Zm0-11c0,.553-.448,1-1,1h-8c-.552,0-1-.447-1-1s.448-1,1-1h8c.552,0,1,.447,1,1Zm-4,4c0,.553-.448,1-1,1h-4c-.552,0-1-.447-1-1s.448-1,1-1h4c.552,0,1,.447,1,1Z"/></svg> -->
              <svg class="h-4 w-4 text-emerald-500 fill-current" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24">
                <path d="m13,5v2H5v-2h8Zm-7,6h6v-2h-6v2Zm17,4.764v5.236c0,1.654-1.346,3-3,3H1V0h17c1.654,0,3,1.346,3,3v8.764l2,4ZM3,22h12V2H3v20Zm18-5.764l-2-4V3c0-.551-.448-1-1-1h-1v20h3c.552,0,1-.449,1-1v-4.764Z"/>
              </svg>
              <p class="text-left text-size-md font-medium text-gray-600">Request Summary</p>
            </div>
            <!--  chart -->
            <div class="ml-8 pb-8 mt-4">
              <div
                class="ring-1 py-2 text-left cursor-pointer ring-gray-200 shadow-md mr-8 pl-1 chart-height"
              >
                <div class="px-4 py-3 space-y-2.5">
                  <div class=" mx-2 mb-5 py-2 grid grid-flow-row grid-cols-1 gap-6">
                    <!-- the selector tab -->
                    <div class="flex mb-2 justify-center">
                      <div class="my-auto">
                        <button @click="switchView(1)" :class="[ currentView == 1 ? 'shadow inline-block box-shadow text-size-sm px-20 py-2 bg-emerald-700  text-white font-medium leading-tight transform focus:bg-emerald-700 focus:outline-none focus:ring-0 active:bg-emerald-800 transition duration-150 ease-in-out' : 'shadow inline-block box-shadow text-size-sm px-10 py-2 bg-emerald-600  text-white font-medium leading-tight transform focus:bg-emerald-600 focus:outline-none focus:ring-0 active:bg-emerald-800 transition duration-150 ease-in-out']">View Create a Service Report Step 1</button>
                        <button @click="switchView(2)" :class="[ currentView == 2 ? 'shadow inline-block box-shadow text-size-sm px-20 py-2 bg-emerald-700  text-white font-medium leading-tight transform focus:bg-emerald-700 focus:outline-none focus:ring-0 active:bg-emerald-800 transition duration-150 ease-in-out' : 'shadow inline-block box-shadow text-size-sm px-10 py-2 bg-emerald-600  text-white font-medium leading-tight transform focus:bg-emerald-600 focus:outline-none focus:ring-0 active:bg-emerald-800 transition duration-150 ease-in-out']">View Create a Service Report Step 2</button>
                      </div>
                    </div>
                    <!-- {{ createServiceReportStep2 }} -->
                    <!-- step 1 -->
                    <table v-if="serviceReportData !== null && currentView === 1" id="datatable" class="table-auto w-full shadow-md cursor-pointer">
                        <thead>
                          <tr class="bg-emerald-600 text-size-xs pointer-events-none" style="">
                            <td class="py-2.5 px-2 text-left text-white font-bold">Item</td>
                            <td class="py-2.5 px-2 text-left text-white font-bold">Description</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class=" text-gray-600 text-size-sm" style="">
                            <td class="py-2.5 px-2 border text-left font-medium">Service Report Type</td>
                            <td class="py-2.5 px-2 border text-left">{{ serviceReportData.report.serviceReportType.name }}</td>
                          </tr>
                          <tr class=" text-gray-600 text-size-sm" style="">
                            <td class="py-2.5 px-2 border text-left font-medium">Resource Id</td>
                            <td class="py-2.5 px-2 border text-left">{{ serviceReportData.report.resourceId }}</td>
                          </tr>
                          <tr class=" text-gray-600 text-size-sm" style="">
                            <td class="py-2.5 px-2 border text-left font-medium">Project</td>
                            <td class="py-2.5 px-2 border text-left">{{ serviceReportData.report.project.name }}</td>
                          </tr>
                          <tr class=" text-gray-600 text-size-sm" style="">
                            <td class="py-2.5 px-2 border text-left font-medium">Report period</td>
                            <td class="py-2.5 px-2 border text-left">{{ formatData(serviceReportData.report.reportPeriod) }}</td>
                          </tr>
                          <tr class=" text-gray-600 text-size-sm" style="">
                            <td class="py-2.5 px-2 border text-left font-medium">Health Facility</td>
                            <td class="py-2.5 px-2 border text-left">{{ serviceReportData.report.healthFacility.name }}</td>
                          </tr>
                        </tbody>
                    </table>
                    <!-- multi function service report -->
                    <div v-if="serviceReportData?.report?.type === 'Multi Function Service Report' && currentView === 2" class="space-y-2">
                      <div class="text-size-xs font-medium text-gray-600">
                        <span>{{ serviceReportData?.report?.type }}</span>
                      </div>
                      <table  id="datatable" class="table-auto w-full shadow-md cursor-pointer">
                          <thead>
                            <tr class="bg-emerald-600 text-size-xs pointer-events-none" style="">
                              <td class="py-2.5 px-2 text-left text-white font-bold">Description</td>
                              <td class="py-2.5 px-2 text-left text-white font-bold">Planned</td>
                              <td class="py-2.5 px-2 text-left text-white font-bold">Achieved</td>
                              <td class="py-2.5 px-2 text-left text-white font-bold">Completion</td>
                              <td class="py-2.5 px-2 text-left text-white font-bold">Observations</td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(data, i) in serviceReportData?.report?.data" :key="i" class=" text-gray-600 text-size-sm" style="">
                              <td class="py-2.5 px-2 border text-left font-medium">{{ data.description }}</td>
                              <td class="py-2.5 px-2 border text-left">{{ data.planned }}</td>
                              <td class="py-2.5 px-2 border text-left">{{ data.achieved }}</td>
                              <td class="py-2.5 px-2 border text-left">{{ data.completion }}</td>
                              <td class="py-2.5 px-2 border text-left">{{ data.observations }}</td>
                            </tr>
                          </tbody>
                      </table>
                    </div>

                    <!-- mservice report -->
                    <div v-if="serviceReportData?.report?.type === 'Service Report' && currentView === 2" class="space-y-2">
                      <div class="text-size-xs font-medium text-gray-600">
                        <span>{{ serviceReportData?.report?.type }}</span>
                      </div>
                      <table  id="datatable" class="table-auto w-full shadow-md cursor-pointer">
                          <thead>
                            <tr class="bg-emerald-600 text-size-xs pointer-events-none" style="">
                              <td class="py-2.5 px-2 text-left text-white font-bold">Date</td>
                              <td class="py-2.5 px-2 text-left text-white font-bold">Alcancar</td>
                              <td class="py-2.5 px-2 text-left text-white font-bold">ViiV</td>
                              <td class="py-2.5 px-2 text-left text-white font-bold">JDC</td>
                              <td class="py-2.5 px-2 text-left text-white font-bold">Gates</td>
                              <td class="py-2.5 px-2 text-left text-white font-bold">Total</td>
                              <td class="py-2.5 px-2 text-left text-white font-bold">Observations</td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(data, i) in serviceReportData?.report?.data" :key="i" class=" text-gray-600 text-size-sm" style="">
                              <td class="py-2.5 px-2 border text-left font-medium">{{ formatData(data.date) }}</td>
                              <td class="py-2.5 px-2 border text-left">{{ data.alcancar }}</td>
                              <td class="py-2.5 px-2 border text-left">{{ data.viiv }}</td>
                              <td class="py-2.5 px-2 border text-left">{{ data.jdc }}</td>
                              <td class="py-2.5 px-2 border text-left">{{ data.gates }}</td>
                              <td class="py-2.5 px-2 border text-left">{{ data.total }}</td>
                              <td class="py-2.5 px-2 border text-left">{{ data.observations }}</td>
                            </tr>
                          </tbody>
                      </table>
                    </div>
                    
                    <!-- multi function service report -->
                    <div v-if="serviceReportData?.report?.type === 'Data Clerks Report' && currentView === 2" class="space-y-2">
                      <div class="text-size-xs font-medium text-gray-600">
                        <span>{{ serviceReportData?.report?.type }}</span>
                      </div>
                      <table  id="datatable" class="table-auto w-full shadow-md cursor-pointer">
                          <thead>
                            <tr class="bg-emerald-600 text-size-xs pointer-events-none" style="">
                              <td class="py-2.5 px-2 text-left text-white font-bold">Goal</td>
                              <td class="py-2.5 px-2 text-left text-white font-bold">Percentage Achieved</td>
                              <td class="py-2.5 px-2 text-left text-white font-bold">Supervisor Percentage</td>
                              <td v-if="isSupervisor" class="py-2.5 px-2 text-center text-white font-bold">Action</td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(data, i) in serviceReportData?.report?.data" :key="i" class=" text-gray-600 text-size-sm" style="">
                              <td class="py-2.5 px-2 border text-left font-medium">{{ data.goal }}</td>
                              <td class="py-2.5 px-2 border text-left">{{ data.percentageAchieved }}</td>
                              <td class="py-2.5 px-2 border text-left">{{ data.supervisorScore }}</td>
                              <td v-if="data.goal === 'Total' && isSupervisor"></td>
                              <td v-else-if="isSupervisor" class="py-2.5 px-2 border text-center">
                                <button @click="openDataClerksEditPercentageModal()" class="bg-emerald-500 text-size font-medium text-white px-4 py-1 shadow-md">Edit</button>
                              </td>
                            </tr>
                          </tbody>
                      </table>
                    </div>
                  </div>
                <div class="w-full flex text-center mx-auto pt-1">
                  <div class="flex-1 mb-2">
                      <button
                        @click="showDenialModal()"
                        class="shadow inline-block box-shadow text-size-sm px-16 py-2 bg-emerald-500  text-white font-medium leading-tight transform focus:bg-emerald-500 focus:outline-none focus:ring-0 active:bg-emerald-800 transition duration-150 ease-in-out">
                          Deny
                      </button>
                       <button
                        @click="approve(1, '')"
                        class="shadow inline-block box-shadow text-size-sm px-16 py-2 bg-emerald-500  text-white font-medium leading-tight transform focus:bg-emerald-500 focus:outline-none focus:ring-0 active:bg-emerald-800 transition duration-150 ease-in-out">
                          Approve
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- the loader modal -->
    <Loader ref="loaderRef"/>
    <!-- the message loader -->
    <Message :title="title" :message="processMessage" ref="messageRef"/>
    <SignatureOption
      :isOk="isOk"
      :title="'Signature Submission'"
      ref="signatureOptionModal"
      @selectedFeedback="(option) => {
        openSignatureModal(option)
      }"
    />
    <Signature
      @approveted = "(data) => {
        signatureCheck()
      }"
      ref="signatureModal"
    />
    <SignatureUpload
      @approveted = "(data) => {
        signatureCheck()
      }"
      ref="signatureUploadModal"
    />
      <!-- feedback modal -->
    <Feedback
        :isOk="isOk"
        :title="'Denial Reasons'"
        ref="feedbackModal"
        @selectedFeedback="(item) => {
          approve(2, item)
        }"
      />
    <!-- feedback modal -->
    <ServiceReportSupervisorUpdate
        :isOk="isOk"
        :title="'Data Clerks Report Update'"
        ref="supervisorServiceUpdateModal"
        @submit="(data) => {
          updateServiceReport(data)
        }"
      />
      <!-- multifunction supervisor update modal -->
      <MultiFunctionServiceReportSupervisorUpdate
        :isOk="isOk"
        :title="'Multi Function Report Update'"
        ref="multiFunctionSupervisorServiceUpdateModal"
        @submit="(data) => {
          updateMultiServiceReport(data)
        }"
      />
  </div>
</template>

<script>
import Navbar from '@/components/EmployeeNavbar.vue'
import Sidebar from '@/components/EmployeeSideBar.vue'
import { mapState } from 'vuex'
import { ajax } from 'rxjs/ajax'
import Message from './modals/Message.vue';
import Loader from './modals/Loader.vue';
import SignatureOption from './modals/SignatureOption.vue';
import Signature from './modals/Signature.vue';
import SignatureUpload from './modals/SignatureUpload.vue';
import Feedback from './modals/Feedback.vue'
import ServiceReportSupervisorUpdate from './modals/ServiceReportSupervisorUpdate.vue';
import MultiFunctionServiceReportSupervisorUpdate from './modals/MultiFunctionServiceReportSupervisorUpdate.vue';

export default {
  computed: {
    ...mapState([
      'employee',
      'createServiceReportStep1',
      'createServiceReportStep2'
    ])
  },
  components: {
    Navbar,
    Sidebar,
    Loader,
    Message,
    Feedback,
    SignatureOption,
    Signature,
    SignatureUpload,
    ServiceReportSupervisorUpdate,
    MultiFunctionServiceReportSupervisorUpdate
  },
  setup () {
    return {
    }
  },
  name: 'admin-home',
  props: {
  },
  data: () => {
    return {
      advanceData: null,
      torData: null,
      title: 'Message Error',
      processMessage: '',
      signatureAvailable: false,
      documentsView: [true, false],
      currentView: 1,
      isSupervisor: false,
      supervisorReviewed: false,
      serviceReportData: null,
      checkedBySupervisor: false,
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    }
  },
  mounted () {
    // removing the submenu items selection
    if (this.employee !== null) {
      this.$store.commit('mutateActiveListItemIndex', 700)
      this.$store.commit('mutateSelectedSubMenuItem', 700)

      // check the signature
      this.signatureCheck()

      // getting the pending activity approvals
      this.getServiceReport()
    }
  },
  methods: {
      // update the service report dataa and observations
    updateMultiServiceReport (data) {
      const id = localStorage.getItem('serviceReportId')

      const observable = ajax({
        method: 'PUT',
        url: process.env.VUE_APP_BASE_URL + `/service-report/supervisorMultiFunctionServiceUpdate`,
        headers: {
          Authorization: `Bearer ${this.employee.token}`
        },
        body: {
          id: id,
          paymentPercentage: data
        }
      })

      const observer = {
        next: () => {
          this.checkedBySupervisor = true
        },
        error: () => {
        },
        complete: () => {
          this.getServiceReport()
        }
      }

      observable.subscribe(observer)
    },
    // update the service report dataa and observations
    updateServiceReport (data) {
      const id = localStorage.getItem('serviceReportId')

      const observable = ajax({
        method: 'PUT',
        url: process.env.VUE_APP_BASE_URL + `/service-report/supervisorUpdate`,
        headers: {
          Authorization: `Bearer ${this.employee.token}`
        },
        body: {
          id: id,
          reportData: data.data,
          observations: data.observations
        }
      })

      const observer = {
        next: () => {
          this.checkedBySupervisor = true
        },
        error: () => {
        },
        complete: () => {
          this.getServiceReport()
        }
      }

      observable.subscribe(observer)
    },
    // check if the approver is the supervisor
    supervisorCheck () {
       const observable = ajax({
        method: 'GET',
        url: process.env.VUE_APP_BASE_URL + `/subordinate/findSubordinateByManagerId?id=${this.employee.id}`,
        headers: {
          Authorization: `Bearer ${this.employee.token}`
        }
      })

      const observer = {
        next: (response) => {
          const data = response.response
          const size = data.length

          // set the data
          if (size > 0) {
            const requestorEmployeeId = this.serviceReportData?.employee_id
            this.isSupervisor = data.some((data) => data.employee_id === requestorEmployeeId)
          }
        },
        error: () => {
        },
        complete: () => {
        }
      }

      observable.subscribe(observer)
    },
    // show the denial modal
    showDenialModal () {
      this.isOk = false
      this.$refs.feedbackModal.openMessageModal()
    },
    // gets the service report
    getServiceReport () {
      const id = localStorage.getItem('serviceReportId')
      const observable = ajax({
        method: 'GET',
        url: process.env.VUE_APP_BASE_URL + `/service-report/findById?id=${id}`,
        headers: {
          Authorization: `Bearer ${this.employee.token}`
        }
      })

      const observer = {
        next: (response) => {
          const data = response.response
          const size = data.length

          // set the data
          if (size > 0) {
            this.serviceReportData = data[0]
          }
        },
        error: () => {
        },
        complete: () => {
          // check if the employee is the supervisor
          this.supervisorCheck()
        }
      }

      observable.subscribe(observer)
    },
    // calculates the grand totals of all the advances
    calculateAdvanceTotals () {
      let grandTotal = 0

      // get the advance grand totals
      let mieTotal = 0

      if (this.mieAdvance !== null && Array.isArray(this.mieAdvance) && this.mieAdvance.length > 0) {
        const size = this.mieAdvance.length
        mieTotal = parseFloat(this.mieAdvance[(size - 1)].advance)
      }

      let mieIntlTotal = 0
      if (this.mieIntlAdvance !== null && Array.isArray(this.mieIntlAdvance) && this.mieIntlAdvance.length > 0) {
        const size = this.mieIntlAdvance.length
        mieIntlTotal = parseFloat(this.mieIntlAdvance[(size - 1)].advance)
      }

      let lodgingCost = 0
      if (this.lodgingAdvance !== null && Array.isArray(this.lodgingAdvance) && this.lodgingAdvance.length > 0) {
        const size = this.lodgingAdvance.length
        const total = this.lodgingAdvance[(size-1)].total

        lodgingCost = parseFloat(total)
      }

      let otherTotal = 0
      if (this.otherAdvance !== null && Array.isArray(this.otherAdvance) && this.otherAdvance.length > 0) {
        const size = this.otherAdvance.length
        const total = this.otherAdvance[(size-1)].total

        otherTotal = parseFloat(total)
      }

      grandTotal = mieTotal + mieIntlTotal + lodgingCost + otherTotal 
      return grandTotal
    },
    openSignatureModal (option) {
      // open the upload modal
      if (option === 1) {
        this.$refs.signatureUploadModal.openSignatureModal()
      } else {
        // open the signature pad
        this.$refs.signatureModal.openSignatureModal()
      }
    },
    signatureCheck () {
      const observable = ajax({
        method: 'GET',
        url: process.env.VUE_APP_BASE_URL + `/signature/findByEmployeeId?id=${this.employee.id}`,
        headers: {
          Authorization: `Bearer ${this.employee.token}`
        }
      })

      const observer = {
        next: (response) => {
          const data = response.response
          const size = data.length
          // show the modal if the signature is not there
          if (size === 0) {
            this.$refs.signatureOptionModal.openMessageModal()
          } else {
            this.signatureAvailable = true
          }
        },
        error: () => {
        },
        complete: () => {
        }
      }

      observable.subscribe(observer)
    },
    // file size converter
    fileSizeFormatter (bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) {
        return '0 Bytes'
      }
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
    },
    // switch the view
    switchView (index) {
      this.documentsView[(index - 1)] = true
      this.currentView = index
    },
    // date difference in days
    dateDiff (startDate, endDate) {
      const date2 = new Date(endDate)
      const date1 = new Date(startDate)

      const _MS_PER_DAY = 1000 * 60 * 60 * 24;
      // remove the time and time-zone details.
      const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
      const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());

      return (Math.floor((utc2 - utc1) / _MS_PER_DAY) + 1);
    },
    // format the table data
    formatData (data) {
      var formattedData
      // check if it is a number
      if (data !== null && data !== undefined && !isNaN(data) && String(data).length > 2) {
        // format the number to a currency format
        var currencyFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'MWK' })
        formattedData = currencyFormat.format(String(data)).substring(4)
      } else if (data !== null && data !== undefined && data.toString().includes('-') && !isNaN(Date.parse(data))) {
        // check if the data is a date
        // formating the dates supplied
        var textDate = new Date(data)
        var formattedTextDate = textDate.getDate() + ' ' + this.months[textDate.getMonth()] + ' ' + textDate.getFullYear()
        formattedData = formattedTextDate
      } else {
        formattedData = data
      }
      return formattedData
    },
    // calculates the date difference in days for the schedule days
    dateDiffInDays () {
        // the date which the activity starts
        const days = []
        const scheduleSize = this.scheduleData.length

        for (let i = 0; i < scheduleSize; i++) {
          const startDate = this.scheduleData[i].startDate
          days.push(startDate)
        }

        // sort the days and get the minimum day
        days.sort()
        const miniDate = days[0]
        const dateFrom = new Date(miniDate)


        // today's date
        const dateTo = new Date()

        const _MS_PER_DAY = 1000 * 60 * 60 * 24;
        // remove the time and time-zone details.
        const utc1 = Date.UTC(dateFrom.getFullYear(), dateFrom.getMonth(), dateFrom.getDate());
        const utc2 = Date.UTC(dateTo.getFullYear(), dateTo.getMonth(), dateTo.getDate());

        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
      },
    // move to the next page
    back () {
      // move to the next page
      this.$router.push('/create-service-report-2')
    },
    // expands or collapses the main body
    expand (value) {
      this.expandBody = value
    },
    // delete the request vuex data
    clearVuex () {
      this.$store.commit('mutateCreateServiceReportStep1', null)
      this.$store.commit('mutateCreateServiceReportStep2', null)
    },
    openDataClerksEditPercentageModal () {
      this.$refs.supervisorServiceUpdateModal.setReportData(this.serviceReportData?.report?.data)
      this.$refs.supervisorServiceUpdateModal.openMessageModal()
    },
    // approve the service report
    approve (statusId, feedback) {
      if (statusId !== 2 && this.serviceReportData?.report?.type !== 'Service Report' && this.isSupervisor && !this.checkedBySupervisor) {
        if (this.serviceReportData?.report?.type !== 'Multi Function Service Report') {
          // show the edit modal
          this.openDataClerksEditPercentageModal()
        } else {
          this.$refs.multiFunctionSupervisorServiceUpdateModal.openMessageModal()
        }
      } else if (!this.signatureAvailable) {
        this.$refs.signatureOptionModal.openMessageModal()
      
      } else if (!this.documentsView.every(value => value === true)) {
        var message = 'Before approveting your request: \n'
        if (this.documentsView[1] === false) {
          message += '  - Please view & verify the the second service report step. \n'
        }

        message += 'Click on the buttons above to view & verify the entered details.'
        this.processMessage = message
        // open the error modal
        this.$refs.messageRef.openModal()
      
      } else {
        // open the loading modal
        this.$refs.loaderRef.openModal()

        // gettting the service report id
        const serviceReportId = localStorage.getItem('serviceReportId')

        const observable = ajax({
          url: process.env.VUE_APP_BASE_URL + '/service-report-approval/insert',
          method: 'POST',
          body: {
            status_id: statusId,
            employee_id: this.employee.id,
            service_report_id: serviceReportId,
            feedback: feedback
          },
          headers: {
            Authorization: `Bearer ${this.employee.token}`
          }
        })

        const observer = {
          next: () => {
            // move to the pending service reports page
            this.$router.push('/employee-approve-service-reports')
          },
          error: () => {
            // close the loader modal
            this.$refs.loaderRef.closeModal()
            // showing the dialog for the error
            this.processMessage = 'Failed to approve the liquidation, please try again.'
            // open the error modal
            this.$refs.messageRef.openModal()
          },
          complete: () => {
            this.$refs.loaderRef.closeModal()
            
          }
        }

        observable.subscribe(observer)
      }
    }
  }
}
</script>

<style>

#chart-container {
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;
  height: 40vh;
}

</style>
